import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  titleContainer: {
    padding: "50px 0px 10px 0px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      padding: "8px 0px",
    },
  },
  questionTitle: {
    color: "#003E4C",
    fontWeight: "600",
    fontSize: 38,
    textAlign: "center",
    // textTransform: "uppercase",
    fontFamily: "'Oswald',sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: 28,
    },
    [mobileScreen(theme)]: {
      fontSize: 18,
    },
  },
  belowTitle: {
    color: "#003E4C",
    fontWeight: "600",
    paddingTop: 30,
    // fontSize: 28,
    textAlign: "center",
    // textTransform: "uppercase",
    fontFamily: "'Oswald',sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: 24,
    },
    [mobileScreen(theme)]: {
      fontSize: 16,
      paddingTop: 8,
    },
  },
  submitButton: {
    color: "#fff",
    backgroundColor: "#00b1d9",
    fontSize: "28px",
    fontWeight: "500",
    padding: "0px 20px",
    margin: "20px 0px 3px 0px",
    borderRadius: "10px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [emulatorScreen(theme)]: {
      fontSize: "24px",
    },
    [mobileScreen(theme)]: {
      fontSize: 16,
      padding: "0px 10px",
      margin: 0,
      marginTop: 8,
    },
  },

  questionComponents: {
    width: 950,
    display: "flex",
    justifyContent: "space-evenly",
    [emulatorScreen(theme)]: {
      width: 860,
    },
    [mobileScreen(theme)]: {
      width: 700,
    },
  },
  estimate: {
    fontFamily: "'Rubik',sans-serif",
    // position: "absolute",
    // top: -30,
    marginTop: 15,
    fontSize: 20,
    color: "#003E4C",
    PointerEvent: "none",
    fontWeight: "500",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      fontSize: 18,
      // marginTop: 5,
    },
  },
});
export default styles;
